import "./pdp-configurator-loader.scss";

const PDPConfiguratorLoader = () => {
    return (
        <div className="configurator-loader configurator-loadsize">
            <span className="loader-dots"><span></span></span>
        </div>
    )
}


export default PDPConfiguratorLoader;